import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['YardIn'],
});
export const yardinApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllYardIns: builder.query({
      query: () => `yardins/`,
      providesTags: ['YardIn'],
    }),
    findYardInById: builder.query({
      query: (id) => `yardins/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'YardIn', id: result.id }] : ['YardIn'];
      },
    }),
    createYardIn: builder.mutation({
      query: (yardin) => ({
        url: `yardins/`,
        method: 'POST',
        body: yardin,
      }),
      invalidatesTags: ['YardIn'],
    }),
    updateYardIn: builder.mutation({
      query: (yardin) => ({
        url: `yardins/${yardin.id}/`,
        method: 'PATCH',
        body: yardin,
      }),
      invalidatesTags: ['YardIn'],
    }),
    deleteYardIn: builder.mutation({
      query: (yardin) => ({
        url: `yardins/${yardin.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['YardIn'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllYardInsQuery,
  useFindYardInByIdQuery,
  useCreateYardInMutation,
  useUpdateYardInMutation,
  useDeleteYardInMutation,
} = yardinApi;
